export default __webpack_public_path__ + "static/media/page-wrap.cd94ec11.jpg";